module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('refresh', {
    staticClass: "wxc-refresher",
    attrs: {
      "display": _vm.refreshing ? 'show' : 'hide',
      "data-evt-refresh": "",
      "data-evt-pullingdown": ""
    },
    nativeOn: {
      "refresh": function($event) {
        $event.stopPropagation();
        return _vm.onRefresh($event)
      },
      "pullingdown": function($event) {
        $event.stopPropagation();
        return _vm.onPullingDown($event)
      }
    }
  }, [(_vm.newStyleFlag) ? _c('div', {
    ref: "cycle",
    staticClass: "cycle-container weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    ref: "cover1",
    staticClass: "u-cover c1 weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    staticClass: "u-cover-cycle cover1 weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  })]), _vm._v(" "), _c('div', {
    ref: "cover2",
    staticClass: "u-cover c2 weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [_c('div', {
    ref: "cover-cycle",
    staticClass: "u-cover-cycle weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.newStyleFlag) ? _c('figure', {
    directives: [{
      name: "weex-resize",
      rawName: "v-weex-resize",
      value: ("contain"),
      expression: "\"contain\""
    }],
    ref: "arrow",
    staticClass: "arrow-down weex-el weex-image",
    attrs: {
      "src": _vm.ICON_ARROW_DOWN,
      "resize": "contain",
      "data-img-src": _vm.ICON_ARROW_DOWN,
      "weex-type": "image"
    }
  }) : _c('loading-indicator', {
    staticClass: "indicator",
    attrs: {}
  }), _vm._v(" "), _c('p', {
    staticClass: "u-txt weex-el weex-text",
    style: ({
      width: _vm._px2rem((_vm.textWidth + "px"), 75)
    }),
    attrs: {
      "weex-type": "text"
    }
  }, [_vm._v(_vm._s(_vm.refresherText))])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6ab8b267", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ab8b267","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/wxc-refresher/index.vue
// module id = 227
// module chunks = 0 1